export enum AcquaintanceTypeCodesEnum {
  ACQ_TYPE_I = 'ACQ_TYPE_I',
  ACQ_TYPE_II = 'ACQ_TYPE_II',
  ACQ_TYPE_IV = 'ACQ_TYPE_IV',
}
